import Enum from "../../enums/Enum";

const NabidhFormTextEnum = new Enum({
    // Form Header
    Nabidh_Consent_Form_Title: {
        English: "Consent Form to Opt-In",
        Arabic: "نموذج الموافقة على الإشتراك"
    },
    Nabidh_Consent_Form_Header: {
        English: "Consent Form to Opt-In",
        Arabic: "نموذج الموافقة على الإشتراك"
    },

    // Patient Information Section
    Patient_Information: { English: "Patient information:", Arabic: "معلومات المريض:" },
    Name: { English: "Name:", Arabic: "الاسم:" },
    MRN: { English: "MRN:", Arabic: "رقم السجل الطبي:" },
    DOB: { English: "D.O.B:", Arabic: "تاريخ الميلاد:" },

    // Consent Acknowledgment Header
    Consent_Acknowledgment_Header: {
        English: "By signing this form, I hereby ACKNOWLEDGE and AGREE as follows:",
        Arabic: "من خلال التوقيع على هذا النموذج، أقر وأوافق على ما يلي:"
    },

    // Consent Statement 1 - Healthcare providers disclosure
    Consent_Statement_1: {
        English: "My healthcare providers that participate in the NABIDH HIE may disclose my health information to the NABIDH system and/or maybe shared with all healthcare provider participants of NABIDH that are involved in my care in the Emirate of Dubai.",
        Arabic: "قد يقوم مقدمو الرعاية الصحية المتصلون بمنصة نابض بالإفصاح عن معلوماتي الصحية لنظام نابض و/أو مشاركتها مع جميع مقدمي الرعاية الصحية المتصلين بمنصة نابض في إمارة دبي، واللذين يتشاركون في تقديم الرعاية الصحية لي."
    },

    // Consent Statement 2 - Health information scope
    Consent_Statement_2: {
        English: "My health information that will be shared through NABIDH includes information about my diagnoses, test results (x-rays or laboratory), and medications that have been prescribed to me.",
        Arabic: "تتضمن معلوماتي الصحية التي سيتم مشاركتها من خلال منصة نابض، معلومات حول تشخيصي ونتائج الفحوصات (الأشعة السينية أو المختبر) والأدوية التي تم وصفها لي."
    },

    // Consent Statement 3 - Opt-out effect
    Consent_Statement_3: {
        English: "If Opt-Out of Nabidh, such cancellation will not affect the health information to those providers already accessed and copied.",
        Arabic: "في حال قررت الخروج من منصة نابض، فلن يؤثر هذا على المعلومات الصحية الموجودة لدى مقدمي الخدمات الصحية سابقاً والتي تم الوصول إليها ونسخها."
    },

    // Consent Statement 4 - Refusal to sign
    Consent_Statement_4: {
        English: "I understand that my refusal to sign this Consent will not prevent me from receiving care from healthcare providers.",
        Arabic: "أتفهم بأن رفضي للتوقيع على نموذج الموافقة على المشاركة هذا لن يمنعني من تلقي الرعاية من مقدمي خدمات الرعاية الصحية أو من المرافق الأخرى المتصلة بمنصة نابض."
    },

    // Consent Statement 5 - Right to cancel
    Consent_Statement_5: {
        English: "I understand that I have the right to cancel this consent by completing and submitting the \"NABIDH Health Information Exchange Opt-Out Request Form\" to my healthcare provider.",
        Arabic: "أتفهم بأنه لدي الحق في إلغاء نموذج الموافقة على المشاركة هذا من خلال استكمال وتقديم \"نموذج طلب عدم المشاركة في منصة نابض\" إلى مقدم خدمات الرعاية الصحية الخاص بي."
    },

    // Consent Statement 6 - Language interpretation
    Consent_Statement_6: {
        English: "The information related to the NABIDH Consent Form has been interpreted in a language that is understood by me.",
        Arabic: "تم ترجمة وشرح المعلومات المتعلقة بنموذج الموافقة على المشاركة هذا بلغة أفهمها."
    },

    // Consent Statement 7 - Right to copy
    Consent_Statement_7: {
        English: "I have a right to ask for a copy of this form after I sign it.",
        Arabic: "لدي الحق بأن أطلب نسخة من نموذج الموافقة على المشاركة هذا بعد التوقيع عليه من قبلي."
    },

    // Consent options
    Consent_Opt_In: {
        English: "Consent Opt-In: I WANT my health information to be visible within NABIDH.",
        Arabic: "الموافقة على الاشتراك: أريد أن تكون معلوماتي الصحية مرئية داخل منصة نابض."
    },

    Consent_Opt_Out: {
        English: "Consent Opt-Out: I DO NOT WANT my information to be visible within NABIDH.",
        Arabic: "عدم الموافقة على الاشتراك: لا أريد أن تكون معلوماتي مرئية داخل منصة نابض."
    },

    // Guardian/Witness Section
    Guardian_Section_Header: {
        English: "If the patient is under 18 years, or has intellectual disability; or mental incapacity; signature of Parent or legal Guardian is needed",
        Arabic: "إذا كان عمر المريض أقل من 18 عاماً، أو يعاني من إعاقة ذهنية؛ أو العجز العقلي يلزم توقيع ولي الأمر أو الوصي القانوني"
    },

    Parent_Guardian_Name: {
        English: "Parent or legal Guardian Name",
        Arabic: "اسم ولي الأمر أو الوصي القانوني"
    },

    Guardian_Relationship: {
        English: "Legal Guardian Relationship to Patient",
        Arabic: "علاقة الوصي القانوني بالمريض"
    },

    Parent_Guardian_Phone: {
        English: "Parent or legal Guardian Phone Number",
        Arabic: "رقم هاتف ولي الأمر أو الوصي القانوني"
    },

    // Form Fields
    Date: { English: "Date Signed", Arabic: "تاريخ التوقيع" },
    Patient_Name: { English: "Patient Name", Arabic: "اسم المريض" },
    Patient_Signature: { English: "Signature of Patient (or Guardian)", Arabic: "توقيع المريض (أو ولي الأمر / الوصي القانوني)" },
    Witness_Name: { English: "Witness Name", Arabic: "اسم الشاهد" },
    Witness_Signature: { English: "Witness Signature", Arabic: "توقيع الشاهد" },
    Relationship_To_Patient: { English: "Relationship to Patient", Arabic: "العلاقة بالمريض" },

    // Common UI elements
    Yes: { English: "Yes", Arabic: "نعم" },
    No: { English: "No", Arabic: "لا" },
    Previous: { English: "Previous", Arabic: "السابق" },
    Next: { English: "Next", Arabic: "التالي" },
    Save: { English: "Save", Arabic: "حفظ" },
    Clear: { English: "Clear", Arabic: "مسح" },

    // Validation messages
    Signature_Required: { English: "Signature Required", Arabic: "التوقيع مطلوب" },
    Field_Required: { English: "Field cannot be left blank", Arabic: "لا يمكن ترك الحقل فارغًا" },
    Consent_Option_Required: { English: "Please select a consent option before submitting", Arabic: "يرجى اختيار خيار الموافقة قبل الإرسال" },
});

export default NabidhFormTextEnum;
